import { VideoProviderType } from '@/enum/videoProviderType.enum';

export abstract class Content {}

export class ContentVideo extends Content {
  providerId: string;

  providerType: VideoProviderType;
}

export class ContentText extends Content {
  body: string;
}

export class ContentImage extends Content {
  url: string;

  source: string;

  resizeFactor: number;

  description?: string;
}

export class Alternative {
  id: number;

  position: number;

  correct: boolean;

  contents: Content;
}
